// src/pages/dealer/DealerLayout.jsx
import React, { useState } from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useDealerAuth } from "../../context/DealerAuthContext";
import "./DealerLayout.css";

const NAV_ITEMS = [
  { to: "/dealer/dashboard",       icon: "▦",  label: "Dashboard"       },
  { to: "/dealer/listings",        icon: "🚗", label: "Car Bidding"     },
  { to: "/dealer/my-offers",       icon: "🏷️", label: "My Offers"       },
  { to: "/dealer/sell-car",        icon: "➕", label: "List My Car"     },
  { to: "/dealer/my-car-listings", icon: "📋", label: "My Car Listings" },
  { to: "/dealer/payments",        icon: "💳", label: "My Payments"     }, // ✅ NEW
  { to: "/dealer/profile",         icon: "👤", label: "My Profile"      },
];

export default function DealerLayout() {
  const { dealer, logout } = useDealerAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => { logout(); navigate("/dealer/login"); };
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div className="dal-root">
      {sidebarOpen && <div className="dal-overlay" onClick={closeSidebar} />}

      <aside className={`dal-sidebar ${sidebarOpen ? "dal-sidebar--open" : ""}`}>
        <div className="dal-brand">
          <span className="dal-brand-icon">🚗</span>
          <span className="dal-brand-name">CarYugo</span>
          <span className="dal-brand-badge">Dealer</span>
        </div>

        <nav className="dal-nav">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={closeSidebar}
              className={({ isActive }) => `dal-nav-link${isActive ? " dal-nav-link--active" : ""}`}
            >
              <span className="dal-nav-icon">{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="dal-sidebar-footer">
          <div className="dal-user">
            <div className="dal-user-avatar">{(dealer?.name || "D").charAt(0).toUpperCase()}</div>
            <div className="dal-user-info">
              <span className="dal-user-name">{dealer?.name || "Dealer"}</span>
              <span className="dal-user-email">+91 {dealer?.phone || ""}</span>
            </div>
          </div>
          <button className="dal-logout" onClick={handleLogout}>⊗ &nbsp;Logout</button>
        </div>
      </aside>

      <main className="dal-main">
        <div className="dal-topbar">
          <button className="dal-hamburger" onClick={() => setSidebarOpen(o => !o)} aria-label="Toggle menu">☰</button>
          <div className="dal-topbar-right">
            <div className="dal-topbar-badge"><span className="dal-status-dot" />Dealer Portal</div>
          </div>
        </div>
        <div className="dal-content"><Outlet /></div>
      </main>
    </div>
  );
}